import React from "react";
import { PageHero, Section } from "../components/PageShell";
import { VALUES } from "../data/site";

const Values = () => (
    <>
        <PageHero eyebrow={VALUES.eyebrow} title={VALUES.title} />

        <Section>
            <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
                <div className="lg:col-span-7 space-y-12">
                    {VALUES.items.map((it, i) => (
                        <div
                            key={i}
                            className="pb-12 border-b border-[var(--ns-border)] last:border-0 last:pb-0"
                            data-testid={`value-${i}`}
                        >
                            <div className="flex items-baseline gap-5">
                                <span
                                    className="font-display text-sm tabular-nums"
                                    style={{ color: "var(--ns-muted)" }}
                                >
                                    {String(i + 1).padStart(2, "0")}
                                </span>
                                <h2
                                    className="font-display text-2xl lg:text-3xl font-bold tracking-tight"
                                    style={{ color: "var(--ns-ink)" }}
                                >
                                    {it.heading}
                                </h2>
                            </div>
                            <p
                                className="font-body mt-5 text-[17px] leading-relaxed lg:pl-12 max-w-2xl"
                                style={{ color: "var(--ns-body)" }}
                            >
                                {it.body}
                            </p>
                        </div>
                    ))}
                </div>
                <div className="lg:col-span-5">
                    <div className="sticky top-28">
                        <img
                            src={VALUES.image}
                            alt="Industrial infrastructure"
                            className="w-full aspect-[4/5] object-cover grayscale"
                            loading="lazy"
                        />
                    </div>
                </div>
            </div>
        </Section>
    </>
);

export default Values;
